module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen-6f2d0bacf84ce72d219fa93a7df6226e.png";